import { dateDayWeeksBefore } from 'utils/dates';

const d1 = [
  /// Excel 2-jul 
  { opinion: 'Cheap', date: dateDayWeeksBefore(5,5), count : 0 },
  { opinion: 'Undervalued', date: dateDayWeeksBefore(5,5), count : 0 },
  { opinion: 'Fair', date: dateDayWeeksBefore(5,5), count : 0 },
  { opinion: 'Overvalued', date: dateDayWeeksBefore(5,5), count : 1 },
  
  { opinion: 'Cheap', date: dateDayWeeksBefore(4,1), count : 0 },
  { opinion: 'Undervalued', date: dateDayWeeksBefore(4,1), count : 1 },
  { opinion: 'Fair', date: dateDayWeeksBefore(4,1), count : 1 },
  { opinion: 'Overvalued', date: dateDayWeeksBefore(4,1), count : 2 },
  
  { opinion: 'Cheap', date: dateDayWeeksBefore(3,1), count : 0 },
  { opinion: 'Undervalued', date: dateDayWeeksBefore(3,1), count : 3 },
  { opinion: 'Fair', date: dateDayWeeksBefore(3,1), count : 3 },
  { opinion: 'Overvalued', date: dateDayWeeksBefore(3,1), count : 3 },
  
  { opinion: 'Cheap', date: dateDayWeeksBefore(3,2), count : 0 },
  { opinion: 'Undervalued', date: dateDayWeeksBefore(3,2), count : 4 },
  { opinion: 'Fair', date: dateDayWeeksBefore(3,2), count : 3 },
  { opinion: 'Overvalued', date: dateDayWeeksBefore(3,2), count : 5 },
  
  { opinion: 'Fair', date: dateDayWeeksBefore(3,5), count : 0 },
  { opinion: 'Overvalued', date: dateDayWeeksBefore(3,5), count : 4 },
  { opinion: 'Undervalued', date: dateDayWeeksBefore(3,5), count : 4 },
  { opinion: 'Cheap', date: dateDayWeeksBefore(3,5), count : 6 },
  
  { opinion: 'Fair', date: dateDayWeeksBefore(2,2), count : 0 },
  { opinion: 'Overvalued', date: dateDayWeeksBefore(2,2), count : 4 },
  { opinion: 'Undervalued', date: dateDayWeeksBefore(2,2), count : 5 },
  { opinion: 'Cheap', date: dateDayWeeksBefore(2,2), count : 7 },
  
  { opinion: 'Fair', date: dateDayWeeksBefore(2,3), count : 0 },
  { opinion: 'Overvalued', date: dateDayWeeksBefore(2,3), count : 4 },
  { opinion: 'Undervalued', date: dateDayWeeksBefore(2,3), count : 5 },
  { opinion: 'Cheap', date: dateDayWeeksBefore(2,3), count : 9 },

    
  { opinion: 'Fair', date: dateDayWeeksBefore(2,5), count : 0 },
  { opinion: 'Overvalued', date: dateDayWeeksBefore(2,5), count : 5 },
  { opinion: 'Undervalued', date: dateDayWeeksBefore(2,5), count : 6 },
  { opinion: 'Cheap', date: dateDayWeeksBefore(2,5), count : 9 },

    
  { opinion: 'Fair', date: dateDayWeeksBefore(1,3), count : 0 },
  { opinion: 'Overvalued', date: dateDayWeeksBefore(1,3), count : 5 },
  { opinion: 'Undervalued', date: dateDayWeeksBefore(1,3), count : 7 },
  { opinion: 'Cheap', date: dateDayWeeksBefore(1,3), count : 9 },

    
  { opinion: 'Fair', date: dateDayWeeksBefore(1,4), count : 1 },
  { opinion: 'Overvalued', date: dateDayWeeksBefore(1,4), count : 7 },
  { opinion: 'Undervalued', date: dateDayWeeksBefore(1,4), count : 8 },
  { opinion: 'Cheap', date: dateDayWeeksBefore(1,4), count : 9 },

    
  { opinion: 'Fair', date: dateDayWeeksBefore(1,5), count : 2 },
  { opinion: 'Overvalued', date: dateDayWeeksBefore(1,5), count : 8 },
  { opinion: 'Undervalued', date: dateDayWeeksBefore(1,5), count : 8 },
  { opinion: 'Cheap', date: dateDayWeeksBefore(1,5), count : 9 },

      
  { opinion: 'Fair', date: dateDayWeeksBefore(0,0), count : 3 },
  { opinion: 'Overvalued', date: dateDayWeeksBefore(0,0), count : 9 },
  { opinion: 'Undervalued', date: dateDayWeeksBefore(0,0), count : 8 },
  { opinion: 'Cheap', date: dateDayWeeksBefore(0,0), count : 9 },
];

export default d1;
